export default "__VITE_ASSET__fGUxnXJD__"